import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bone">
        <div className="font-mono uppercase tracking-widest text-xs">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/auth?mode=login" replace />;
  if (role && user.role !== role) {
    const dest = user.role === "admin" ? "/admin" : user.role === "contractor" ? "/contractor" : "/customer";
    return <Navigate to={dest} replace />;
  }
  return children;
}
